import FeedbackForm from "../../components/FeedbackForm/FeedbackForm";
import Page from "../../components/Page";

const Feedback = () => {
  return (
    <Page>
              <div style={{ minHeight: '100vh', background: '#faf8f5' }}>
        <div className="section-feedback">
          <FeedbackForm/>
        </div>
      </div>
    </Page>
  )  
};

export default Feedback